import { useState } from 'react';
import { Info } from '@components/atoms/Info';
import { ParameterDto } from '@src/types/types';
import { classNames } from '@utils/classNames.ts';
import { ParameterDetailPopup } from './ParameterDetailPopup';

export const ParameterListItemLeft = ({
  title,
  subtitle,
  parameter,
  wide,
}: {
  title: string;
  subtitle?: string;
  parameter: ParameterDto;
  wide?: boolean;
}) => {
  const [showDetail, setShowDetail] = useState(false);

  return (
    <>
      <div
        className={classNames(
          'flex flex-col gap-1 flex-[0_0_15%]',
          wide
            ? 'md:min-w-[380px] print:min-w-[380px]'
            : 'md:min-w-[280px] print:min-w-[280px]',
        )}
        data-testid="parameter-list-item-left"
      >
        <div className="flex items-center gap-2.5 w-full max-[400px]:max-w-40 max-w-full">
          <span
            className="text-dark font-outfit text-xl md:text-2xl print:text-2xl font-semibold md:font-bold print:font-bold leading-normal md:leading-[27px] print:leading-[27px] lg:line-clamp-2 print:line-clamp-2 max-w-full cursor-pointer"
            onClick={(event) => {
              setShowDetail(true);
              event.stopPropagation();
            }}
          >
            {title}
          </span>
          <Info onClick={() => setShowDetail(true)} className="print:hidden" />
        </div>
        {subtitle && (
          <span className="text-grey1 font-outfit text-base font-normal leading-[20px] w-max max-[400px]:max-w-40">
            {subtitle}
          </span>
        )}
      </div>

      {showDetail && (
        <ParameterDetailPopup
          parameter={parameter}
          onClose={() => setShowDetail(false)}
        />
      )}
    </>
  );
};
